/**
 * TAMIX SAAS PLATFORM - API Configuration Helper
 * Dynamic base URL detection for local development and production environments
 */

export const getApiBaseUrl = (): string => {
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL
  }
  if (typeof window !== 'undefined') {
    const host = window.location.hostname
    if (host.includes('tamix.l3m.mx') || host.includes('l3m.mx') || host.includes('lostresmisisipis.com')) {
      return '/backend'
    }
  }
  return ''
}

export const getApiV1Url = (): string => {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL
  }
  return `${getApiBaseUrl()}/api/v1`
}
